/**
 * Finding Your Voice — Module Metadata Index
 *
 * Metadata for all 8 modules in the programme.
 * Each module follows a narrative arc with Greek guide characters.
 */

export const MODULE_METADATA = [
  {
    id: 1,
    title: 'Why Speaking Feels Scary',
    subtitle: 'In which Philemon pours the first cup badly, and nobody talks him out of his fear',
    primaryCharacter: 'philemon',
    supportingCharacters: ['xenia', 'theron'],
    coreTheme: 'The fear does not have to leave before you speak',
    keyInsight: 'The fear does not have to go before you speak',
  },
  {
    id: 2,
    title: 'Who Are You When You Speak?',
    subtitle: "In which Philemon gives a flawless lecture in another man's voice, and nobody is moved",
    primaryCharacter: 'philemon',
    supportingCharacters: ['xenia'],
    coreTheme: "A borrowed voice can only say what its owner knew",
    keyInsight: "Know what is yours to say before you stand up",
  },
  {
    id: 3,
    title: 'What Do You Actually Want to Say?',
    subtitle: "In which Philemon is made to say it in one sentence, and Theron eats the rest",
    primaryCharacter: 'theron',
    supportingCharacters: ['philemon', 'xenia'],
    coreTheme: "Cut what is only interesting, and say what is left",
    keyInsight: "Say it in one sentence before you say it at length",
  },
  {
    id: 4,
    title: "The Listener's Mindset",
    subtitle: "In which Daria arrives frightened of a room, and Xenia asks her who is in it",
    primaryCharacter: 'xenia',
    supportingCharacters: ['theron', 'philemon'],
    coreTheme: "A room is people, taken one at a time",
    keyInsight: "A room is only people. Pick one and ask what they need.",
  },
  {
    id: 5,
    title: 'Emotion Is Information',
    subtitle: "In which Philemon comes to practise being composed, and leaves without having practised it",
    primaryCharacter: 'philemon',
    supportingCharacters: ['xenia', 'theron'],
    coreTheme: "Hiding a feeling has a cost; letting it show is allowed",
    keyInsight: "Name what you feel, and let it be heard",
  },
  {
    id: 6,
    title: 'Your Body Already Knows',
    subtitle: "In which Theron hides the cushions, Daria rocks like a skiff, and nobody sits",
    primaryCharacter: 'theron',
    supportingCharacters: ['philemon', 'xenia'],
    coreTheme: "Settle the body before you ask it to speak",
    keyInsight: "Settle the body first: feet, shoulders, jaw, three breaths",
  },
  {
    id: 7,
    title: 'Structure Sets You Free',
    subtitle: "In which Daria brings seventeen points, and Theron tells the story he would not tell",
    primaryCharacter: 'theron',
    supportingCharacters: ['philemon', 'xenia'],
    coreTheme: "You cannot carry everything into a room",
    keyInsight: "Carry three words in, and know your first and last sentence",
  },
  {
    id: 8,
    title: 'The Courage to Be Heard',
    subtitle: "In which the first cup is yours, and Theron takes something back",
    primaryCharacter: 'xenia',
    supportingCharacters: ['philemon', 'theron'],
    coreTheme: "Nobody gets steady first",
    keyInsight: "The trembling comes too. Name the next room anyway.",
  },
];

/**
 * Returns module metadata by its ID.
 * @param {number} id — The module ID (1–8)
 * @returns {object|undefined} The module metadata, or undefined if not found.
 */
export const getModuleById = (id) => {
  return MODULE_METADATA.find((module) => module.id === id);
};
